import gql from 'graphql-tag';
import { recursiveString } from 'src/app/utils/string.utils';

const NUMBER_OF_MAX_CHILDREN_NODE = 10;

export class activityAdvancedRuleFragments {
    static advancedComputing = gql`
        fragment CalculsEnfantsFragment on CalculRegleAvanceeModelDTO {
            CalculParent {
                Id
              }
            Status
            Id
            IdOperateur
            IsGroupe
            Ordre
            Valeur
            IdOperateur
            Critere {
                Id
                Parametres {
                    MoleculeRegleAvanceeModelDTO {
                        IdChamp
                        IdOperateur
                        TypeValeur
                        Valeur
                        Critere {
                            Id
                        }
                    }
                }
            }
        }
        fragment CalculRegleAvanceeFragment on CalculRegleAvanceeModelDTO {
            Status
            CalculParent {
                Status
                Id
                IdOperateur
                IsGroupe
                Ordre
                Valeur
            }
            ${recursiveString('CalculsEnfants {\n', '\n}\n,}', 'CalculRegleAvanceeModelDTO {\n ...CalculsEnfantsFragment\n', NUMBER_OF_MAX_CHILDREN_NODE)}
            Critere {
                Status
                Id
                Parametres {
                    MoleculeRegleAvanceeModelDTO {
                        Critere {
                            Id
                        }
                        IdOperateur
                        Valeur
                        IdChamp
                    }
                }
            }
            Id
            IdOperateur
            IsGroupe
            Ordre
            Valeur
        }
    `;
    static advancedRule = gql`
        fragment RegleAvanceeFragment on RegleAvanceeModelDTO {
            CalculSubvention {
                ...CalculRegleAvanceeFragment
            }
            CalculSubventionDefaut {
                ...CalculRegleAvanceeFragment
            }
            Id
            IdEnveloppe
            IdOperateur
            IdRegleApplication
            IdRegleNonApplication
            IdTypeArrondi
            IdTypeDate
            IsComplementaire
            IsForcageAutorise
            IsGroupe
            IsSubChoisie
            IsTransverse
            IsVenteSansSubAutorise
            Jours
            Libelle
            Mois
            Molecule {
                Status
                CalculValeur {
                    ...CalculRegleAvanceeFragment
                }
                Critere {
                    Status
                    Id
                    Parametres {
                        MoleculeRegleAvanceeModelDTO {
                            Status
                            IdChamp
                            IdOperateur
                            TypeValeur
                            Valeur
                            Critere {
                                Id
                            }
                        }
                    }
                }
                IdChamp
                IdOperateur
                TypeValeur
                Valeur
            }
            RegleParent {
                Id
                IdOperateur
                ReglesEnfants {
                    RegleAvanceeModelDTO {
                        Id
                    }
                }
            }
            ReglesEnfants {
                RegleAvanceeModelDTO {
                    Id
                }
            }
            Subvention
            SubventionDefaut
            TypeRegle
        }
    `;
}
